import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StyleHelpersService {

  isRunning:boolean = false;
  timeoutmarqueeAnimationId: any;
  isMobile:boolean = false;
  isDesktop:boolean = false;

  constructor() { }

  getStyles(){
    this.marqueeAnimation()
  }
  
  sizeWindow() {
    this.isMobile = window.matchMedia('(max-width: 668px)').matches;
    this.isDesktop = !window.matchMedia('(max-width: 668px)').matches
  }

  marqueeAnimation(){
    const runDuration = 10000;  // 5 segundos animando
    const pauseDuration = 60000; // 60 segundos pausado

    const starLoop = () =>{
      if (this.isRunning) return;
      this.isRunning = true;
      Loop();
    }

    const stopLoop = () =>{
      this.isRunning = false;
      clearTimeout(this.timeoutmarqueeAnimationId);
      return;
    }

    const Loop = () => {
      if (!this.isRunning) stopLoop();
      const marquee:any = document.getElementById('marquee_alert')
      if (marquee == null) return;

      marquee.classList.add('marquee_animation');
      
      this.timeoutmarqueeAnimationId = setTimeout(() => {
          marquee.classList.remove('marquee_animation'); // inicia animação
          this.timeoutmarqueeAnimationId = setTimeout(() => {
            Loop()
          }, pauseDuration);
        }, runDuration);

    }
    starLoop()
  }
}
